import React from "react";
import { ExplainerSection, NAVY, CYAN, LIME, INK, LIGHT, RED } from "./ExplainerSection";

const Rule321Illu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="3-2-1 Backup-Regel">
    <rect width="400" height="260" fill={LIGHT} />
    {/* 3 Kopien */}
    {[0, 1, 2].map((i) => (
      <rect key={i} x={40 + i * 14} y={70 - i * 10} width="60" height="80" rx="4" fill="#fff" stroke={NAVY} strokeWidth="2" />
    ))}
    <text x="84" y="185" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="22" fontWeight="900" fill={NAVY}>3</text>
    <text x="84" y="202" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>KOPIEN</text>
    {/* 2 Medien: disk + cloud */}
    <circle cx="185" cy="90" r="24" fill="none" stroke={CYAN} strokeWidth="2.5" />
    <circle cx="185" cy="90" r="7" fill={CYAN} />
    <path d="M 220 120 q -4 -16 12 -18 q 4 -14 20 -10 q 14 -6 20 8 q 14 2 10 20 z" fill="none" stroke={CYAN} strokeWidth="2.5" />
    <text x="212" y="185" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="22" fontWeight="900" fill={CYAN}>2</text>
    <text x="212" y="202" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>MEDIEN</text>
    {/* 1 extern (offline) */}
    <rect x="310" y="60" width="55" height="80" rx="4" fill={NAVY} />
    <rect x="320" y="72" width="35" height="6" fill={LIME} />
    <rect x="320" y="84" width="35" height="6" fill={LIME} opacity="0.6" />
    <line x1="285" y1="100" x2="305" y2="100" stroke={RED} strokeWidth="2" strokeDasharray="4 4">
      <animate attributeName="opacity" values="1;0.2;1" dur="1.6s" repeatCount="indefinite" />
    </line>
    <text x="337" y="185" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="22" fontWeight="900" fill={NAVY}>1</text>
    <text x="337" y="202" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>EXTERN</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      DIE 3-2-1-REGEL · UNSER STANDARD
    </text>
  </svg>
);

const AirGapIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Air-Gap trennt Backup vom Netzwerk">
    <rect width="400" height="260" fill={INK} />
    {/* Company server */}
    <rect x="40" y="70" width="80" height="110" rx="4" fill={NAVY} stroke={CYAN} strokeWidth="1.5" />
    {[0, 1, 2].map((i) => (
      <g key={i}>
        <rect x="50" y={82 + i * 32} width="60" height="22" rx="2" fill={INK} stroke={CYAN} strokeWidth="1" />
        <circle cx="100" cy={93 + i * 32} r="3" fill={LIME}>
          <animate attributeName="opacity" values="1;0.3;1" dur="1.5s" begin={`${i * 0.4}s`} repeatCount="indefinite" />
        </circle>
      </g>
    ))}
    <text x="80" y="200" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill="#fff">IHR NETZWERK</text>
    {/* Vault */}
    <rect x="285" y="70" width="85" height="110" rx="6" fill={NAVY} stroke={LIME} strokeWidth="2" />
    <circle cx="327" cy="118" r="22" fill="none" stroke={LIME} strokeWidth="3" />
    <circle cx="327" cy="118" r="6" fill={LIME} />
    <line x1="327" y1="118" x2="327" y2="102" stroke={LIME} strokeWidth="3" />
    <text x="327" y="200" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill="#fff">AIR-GAP TRESOR</text>
    {/* The gap */}
    <line x1="130" y1="125" x2="180" y2="125" stroke={CYAN} strokeWidth="2" />
    <line x1="225" y1="125" x2="275" y2="125" stroke={CYAN} strokeWidth="2" strokeDasharray="6 5" />
    <text x="202" y="112" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill={LIME}>LUFT-</text>
    <text x="202" y="147" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill={LIME}>SPALT</text>
    {/* Ransomware bolt bounced */}
    <path d="M 150 45 l -8 18 h 10 l -8 18" fill="none" stroke={RED} strokeWidth="3" strokeLinejoin="round">
      <animate attributeName="opacity" values="0;1;1;0" dur="2.2s" repeatCount="indefinite" />
      <animateTransform attributeName="transform" type="translate" values="0 0;55 45;55 45" dur="2.2s" repeatCount="indefinite" />
    </path>
    <text x="200" y="80" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={RED} fontWeight="bold">
      <animate attributeName="opacity" values="0;0;1;0" dur="2.2s" repeatCount="indefinite" />
      GESTOPPT ✕
    </text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill="#fff" letterSpacing="2">
      RANSOMWARE KOMMT NICHT ANS BACKUP
    </text>
  </svg>
);

const ActiveProtIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Active Protection schützt Dateien vor Verschlüsselung">
    <rect width="400" height="260" fill={LIGHT} />
    {/* Files row */}
    {[0, 1, 2, 3, 4].map((i) => {
      const x = 50 + i * 62;
      const safe = i > 1;
      return (
        <g key={i}>
          <path d={`M ${x} 90 h 30 l 12 12 v 48 h -42 z`} fill={safe ? "#fff" : "#FADDE1"} stroke={safe ? NAVY : RED} strokeWidth="2" />
          {safe ? (
            <path d={`M ${x + 10} 122 l 8 8 l 14 -16`} fill="none" stroke={LIME} strokeWidth="3" strokeLinecap="round" />
          ) : (
            <g>
              <rect x={x + 12} y={118} width={18} height={14} rx="2" fill={RED} />
              <path d={`M ${x + 15} 118 v -6 q 0 -6 6 -6 q 6 0 6 6 v 6`} fill="none" stroke={RED} strokeWidth="2.5" />
            </g>
          )}
        </g>
      );
    })}
    {/* Shield barrier between file 2 and 3 */}
    <line x1="172" y1="60" x2="172" y2="185" stroke={LIME} strokeWidth="4">
      <animate attributeName="opacity" values="0.5;1;0.5" dur="1.5s" repeatCount="indefinite" />
    </line>
    <path d="M 172 40 l 16 6 v 14 q 0 12 -16 19 q -16 -7 -16 -19 v -14 z" fill={LIME} />
    <text x="172" y="65" textAnchor="middle" fontSize="12" fontWeight="bold" fill={INK}>✓</text>
    <text x="105" y="205" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill={RED}>ANGRIFF ERKANNT</text>
    <text x="285" y="205" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="9" fill={INK}>DATEN GESCHÜTZT ✓</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      ACTIVE PROTECTION STOPPT VERSCHLÜSSELUNG
    </text>
  </svg>
);

const RestoreIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Wiederherstellung in unter 15 Minuten">
    <rect width="400" height="260" fill={INK} />
    {/* Stopwatch */}
    <circle cx="130" cy="120" r="60" fill="none" stroke={CYAN} strokeWidth="3" />
    <rect x="122" y="45" width="16" height="10" fill={CYAN} />
    {[0, 90, 180, 270].map((a) => (
      <line key={a} x1="130" y1="66" x2="130" y2="74" stroke={CYAN} strokeWidth="2" transform={`rotate(${a} 130 120)`} />
    ))}
    <line x1="130" y1="120" x2="130" y2="80" stroke={LIME} strokeWidth="4" strokeLinecap="round">
      <animateTransform attributeName="transform" type="rotate" values="0 130 120;90 130 120;0 130 120" dur="3s" repeatCount="indefinite" />
    </line>
    <circle cx="130" cy="120" r="6" fill={LIME} />
    <text x="130" y="205" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="18" fontWeight="900" fill={LIME}>{"< 15 MIN"}</text>
    {/* Progress bar */}
    <text x="235" y="95" fontFamily="ui-monospace, monospace" fontSize="10" fill="#fff">RESTORE LÄUFT…</text>
    <rect x="235" y="105" width="130" height="14" fill="none" stroke={CYAN} strokeWidth="1.5" />
    <rect x="237" y="107" width="0" height="10" fill={LIME}>
      <animate attributeName="width" values="0;126" dur="3s" repeatCount="indefinite" />
    </rect>
    <text x="235" y="145" fontFamily="ui-monospace, monospace" fontSize="10" fill={LIME}>
      <animate attributeName="opacity" values="0;0;1" dur="3s" repeatCount="indefinite" />
      ✓ SYSTEM WIEDER ONLINE
    </text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill="#fff" letterSpacing="2">
      NOTFALL-RESTORE · GETESTET, NICHT GEHOFFT
    </text>
  </svg>
);

const ITEMS = [
  { step: "01", illu: Rule321Illu, title: "3 Kopien, 2 Medien, 1 extern", desc: "Die goldene Backup-Regel: Ihre Daten existieren dreifach, auf zwei verschiedenen Speicher-Arten – und eine Kopie liegt räumlich getrennt in unserem deutschen Rechenzentrum.", testId: "rule321" },
  { step: "02", illu: AirGapIllu, title: "Ein Luftspalt, den kein Virus überspringt", desc: "Air-Gap bedeutet: Ihr Backup ist physisch vom Netzwerk getrennt. Selbst wenn Ransomware Ihr komplettes Netz verschlüsselt – an den Backup-Tresor kommt sie nicht heran.", testId: "airgap" },
  { step: "03", illu: ActiveProtIllu, title: "Angriffe werden live gestoppt", desc: "Active Protection beobachtet das Verhalten aller Prozesse. Beginnt eine Software plötzlich, massenhaft Dateien zu verschlüsseln, wird sie sofort gestoppt – und betroffene Dateien werden automatisch wiederhergestellt.", testId: "activeprot" },
  { step: "04", illu: RestoreIllu, title: "Wiederherstellung in Minuten", desc: "Ein Backup ist nur so gut wie sein Restore. Wir testen die Wiederherstellung regelmäßig – im Ernstfall steht Ihr System in unter 15 Minuten wieder. Garantiert, nicht gehofft.", testId: "restore" },
];

export const BackupExplainers = () => (
  <ExplainerSection
    eyebrow="So funktioniert Managed Backup"
    titleA="Vier Prinzipien."
    titleB="Einfach erklärt."
    intro="Backup klingt langweilig – bis man es braucht. Hier sehen Sie visuell, warum Ihre Daten bei uns auch dann sicher sind, wenn alles andere schiefgeht."
    items={ITEMS}
    testId="backup-explainers"
  />
);
